function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
/** @jsxRuntime classic */

/** @jsx jsx */

import { jsx, css } from '@emotion/core';
const style = css`
  color: #d33e43;
  font-size: calc(10px + (14 - 10) * ((100vw - 360px) / (1600 - 360)));
`;
/**
 * This component represents a form error
 * @param {string} msg Error msg.
 * @param {boolean} touched This prop represents if the span is touched or not, usually formik.touched is send.
 * @param {*} props All other supported props.
 */

const Error = /*#__PURE__*/React.memo(({
  msg,
  touched,
  ...props
}) => touched ? jsx("span", _extends({
  css: style
}, props), msg) : null);
export default Error;